import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageNavigation } from '../../utils/analytics';

/**
 * Component to automatically track page navigation events
 * This component listens to route changes and sends navigation events to Heap
 */
const PageNavigationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Get the page name from the pathname
    const pageName = getPageNameFromPath(location.pathname);

    // Track the navigation
    trackPageNavigation(pageName, location.pathname, {
      search: location.search,
      hash: location.hash,
    });
  }, [location]);

  return null;
};

/**
 * Helper function to convert pathname to a readable page name
 * @param {string} pathname - The URL pathname
 * @returns {string} - A readable page name
 */
const getPageNameFromPath = pathname => {
  // Handle root path
  if (pathname === '/' || pathname === '') {
    return 'Home';
  }

  // Get the first segment of the path
  const firstSegment = pathname.split('/')[1];

  switch (firstSegment) {
    case 'login':
      return 'Login';
    case 'register':
      return 'Register';
    case 'dashboard':
      return 'Dashboard';
    case 'tasks':
      return 'Tasks';
    case 'settings':
      return 'Settings';
    case 'profile':
      return 'Profile';
    case 'users':
      return 'Users';
    case 'integrations':
      return 'Integrations';
    case 'account-alias':
      return 'Account Alias';
    case 'role-setting':
      return 'Role Setting';
    case 'privilege-settings':
      return 'Privilege Settings';
    case 'exclusion-settings':
      return 'Exclusion Settings';
    default:
      // Capitalize first segment as fallback
      return firstSegment
        ? firstSegment.charAt(0).toUpperCase() + firstSegment.slice(1)
        : 'Unknown Page';
  }
};

export default PageNavigationTracker;
